import { FLUTTER_IFRAME_WRAPPER_MAP } from './../../flutter/flutter.consts.js';
import {
  capitalizeWord,
  addLoadingSpinner,
  removeLoadingSpinner,
  handleProceedToPay,
  sendToGa4
} from './../../flutter/flutter.utils.js';

import('../../scripts/dbs/dbs.utilities.querystring')
// FlutterDeals.js
export default class FlutterPreviewPane {
  constructor() {
    if (process.env.NODE_ENV === 'development') {
      console.log('flutter.preview-pane: initializing');
    }
    this.loadDependencies().then(() => {
      this.initializeProperties();
      this.initializePanel();

      if (this.debugMode) {
        console.log('flutter.preview-pane: initialized');
      }
    });
  }

  async loadDependencies() {
    await Promise.all([
      import(/* webpackMode: "eager" */ './flutter-preview-pane.scss'),
      import(/* webpackMode: "eager" */ '../../scripts/dbs/dbs.utilities.querystring'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal.scss'),
      import(/* webpackMode: "eager" */ '../../scripts/dbs/dbs.utilities.querystring')
    ]);
  }

  initializeProperties() {
    const self = this;
    self.queryString = new dbs.utilities.querystring()
    self.$body = $('body')

    self.$wrapper = $(FLUTTER_IFRAME_WRAPPER_MAP['preview_panel'])
    self.opened = false;
    self.$flutter_preview_panel_frame_wrapper = $('#flutter_preview_frame_wrapper');
    self.$flutter_preview_panel_frame = $('#flutter_preview_frame');
    self.embedBaseUrl = self.$flutter_preview_panel_frame.attr('data-embed-base-url')
    self.msg_receiver = self.$flutter_preview_panel_frame.attr('data-message-receiver')
    self.$flutter_preview_pane_dimmer = $("#flutter_preview_pane_dimmer")


    this.localDebugEnabled = true;
    this.debugMode == this.localDebugEnabled && process.env.NODE_ENV === 'development';
  }

  getAccommodationFilters = () => {
    const self = this;
    const defaultAccommodationFilters = 'All';
    let validSorts = ['Cabin', 'Site'];
    let sortParameterFromUrl = self.queryString.getParameter('accommodationType');

    if (sortParameterFromUrl != self && validSorts.includes(sortParameterFromUrl)) {
      return [capitalizeWord(self.queryString.getParameter('accommodationType'))]
    }

    return defaultAccommodationFilters;
  }

  // handleEvent - Handles the event from the iframe
  // @param {string} eventType - The event type
  // @param {object} eventData - The event data
  // @returns {void}
  handleEvent(eventType, eventData) {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.events.handleDealsEvent: received event', eventType, eventData);
    }
    removeLoadingSpinner(this.$wrapper)
    switch (eventType) {
      case 'ga4Event':
        if (process.env.NODE_ENV === 'development') {
          console.log('sendToGa4', eventData);
        }
        sendToGa4(eventData);
        break;
      case 'onAppStarted':
        removeLoadingSpinner(this.$wrapper)
        break;
      case 'onResize':
        if (process.env.NODE_ENV === 'development') {
          debugger; // TODO Potentially handle this? Not sure
        }
        removeLoadingSpinner(this.$wrapper)
        break;
      case 'bookingContextChanged':
        this.handleBookingContextChange(eventData);
        break;
      case 'proceedToPay':
        const index = parseInt($('#flutter_preview_frame iframe').attr('data-index')) ?? 0;
        debugger;
        handleProceedToPay(eventData, index);
        break;
      case 'closePreview':
        this.toggle();
        break;
      default:
        if (self.debugMode) {
          console.log('flutter.events.handleDealsEvent: unhandled event', eventType, eventData);
        }
        break;
    }
  }

  // handleBookingContextChange - Handles the booking context change event
  // @param {object} eventData - The event data to process
  // @returns {void}
  handleBookingContextChange(eventData) {
    window.dbs.globalEvents.emit('update_k13_accommodation_widget', eventData, true)
  }

  // toggle - Toggles the preview pane
  // @returns {void}
  toggle = () => {
    const self = this;
    self.$flutter_preview_panel_frame_wrapper.toggleClass('open');
    self.$flutter_preview_pane_dimmer.toggleClass('active');
    self.$body.toggleClass('no-scroll');
    if (self.opened) {
      this.destroy();

    }
    self.opened = this.opened == true ? false : true;
    // Set timeout to check if it's loaded or still showing about:blank
  }

  // createIframe - Creates an iframe with the embed URL
  // @param {string} embedUrl - The embed URL to use
  // @returns {void}
  createIframe = (embedUrl, index) => {
    const self = this;
    const url = self.embedBaseUrl + embedUrl
    console.log(url);
    var iframe = `<iframe src="${url}" scrollable="no" frameborder="0" seamless class="flutter-iframe" style="min-height:90dvh" data-index="${index}"></iframe>`
    var iframes = self.$flutter_preview_panel_frame.find('iframe')
    if (iframes.length > 0) {
      // remove iframes
      iframes.remove();
    }
    addLoadingSpinner(this.$flutter_preview_panel_frame);
    self.$flutter_preview_panel_frame.append(iframe);
    self.toggle();

    // Create and instantiate the iframe with the embedURL
  }
  // destroy - Destroys the iframe
  // @returns {void}
  destroy = () => {
    const self = this;
    const iframes = self.$flutter_preview_panel_frame.find('iframe')
    if (iframes.length > 0) {
      // remove iframes
      iframes.remove();
      let bookingUrl = new URL(window.location.href);
      // Remove the booking parameter
      bookingUrl.searchParams.delete('previewPaneOpen');
      // Replace state instead of pushing
      window.history.replaceState({}, "", bookingUrl);
    }
  }

  handlePopState = () => {

  }

  // initializePanel - Initializes the panel
  // @returns {void}
  initializePanel = () => {
    const self = this;

    let bookingUrl = new URL(window.location.href);
    // Remove the panel opening because we're loading the page, it shouldn't be open or exist yet
    if (bookingUrl.searchParams.get('previewPaneOpen')) {
      bookingUrl.searchParams.delete('previewPaneOpen');
      window.history.replaceState({}, "", bookingUrl);
    }
    if (self.debugMode) {
      console.log('flutter.preview-pane: initializing');
    }
    $('body').on('click', '#invisible_panel_close_button', function () {
      self.toggle()
    })
    window.addEventListener('popstate', function (event) {
      //removing the weird pane for toggling
      self.handlePopState();
      if(self.opened) {
        self.toggle()
      }
    });

    $('body').on('click', '#flutter_preview_pane_dimmer', function () {
      self.toggle();
    })

    $('body').on('click', '.trigger-preview-window', function (e) {
      e.preventDefault();
      if ($('.loading-overlay').is(':visible')) {
        return; // don't load while loading
      }
      if (document.readyState === "complete") {
        // set interop state from URL params + the accommodation that was clicked
        let clicked = $(e.currentTarget);

        let parkCode = $('.widget.accommodation-availability').attr('data-propertycode');
        let accommodationRoomCode = clicked.attr('data-accommodation-room-code');
        let accomIndex = parseInt(clicked.attr('data-index')) ?? 0;
        let checkIn = self.queryString.getParameter('arrive') ?? moment().format('YYYY-MM-DD');
        let checkOut = self.queryString.getParameter('depart') ?? moment().format('YYYY-MM-DD');
        let adults = parseInt(self.queryString.getParameter('adults')) ?? 2;
        let infants = parseInt(self.queryString.getParameter('infants')) ?? 0;
        let children = parseInt(self.queryString.getParameter('kids')) ?? 0;
        let accommodationTypeFilter = self.getAccommodationFilters();
        // Construct embed URL
        let urlParams = {
          'parkCode': parkCode,
          'accommodationRoomCode': accommodationRoomCode,
          'accomIndex': accomIndex,
          'checkIn': checkIn,
          'checkOut': checkOut,
          'adults': adults,
          'children': children,
          'infants': infants,
          'accommodationTypeFilter': accommodationTypeFilter
        };
        // add dealCode to urlParams if deal code is currently applied.
        if (self.queryString.getParameter('dealCode') && self.queryString.getParameter('dealCode') != "") {
          urlParams.dealCode = self.queryString.getParameter('dealCode');
        }

        // this appends history for mobile back button

        let bookingUrl = new URL(window.location.href);
        bookingUrl.searchParams.append('previewPaneOpen', true);
        window.history.pushState({}, "", bookingUrl);

        const embedUrl = self.createUrl(urlParams)
        self.createIframe(embedUrl, accomIndex);
        window.setTimeout(function () {
          removeLoadingSpinner(self.$wrapper)
        }, 1500);
      }

    });

    if (self.queryString.getParameter('openPreviewWindow')) {
      let parkCode = self.queryString.getParameter('propertyCode');
      let accommodationRoomCode = self.queryString.getParameter('accommodationRoomId');
      let accomIndex = parseInt(clicked.attr('data-index')) ?? 0;
      let checkIn = self.queryString.getParameter('arrive') ?? moment().format('YYYY-MM-DD');
      let checkOut = self.queryString.getParameter('depart') ?? moment().format('YYYY-MM-DD');
      let adults = parseInt(self.queryString.getParameter('adults')) ?? 2;
      let infants = parseInt(self.queryString.getParameter('infants')) ?? 0;
      let children = parseInt(self.queryString.getParameter('kids')) ?? 0;
      let accommodationTypeFilter = self.getAccommodationFilters();
      // Construct embed URL
      let urlParams = {
        'parkCode': parkCode,
        'accommodationRoomCode': accommodationRoomCode,
        'accomIndex': accomIndex,
        //'index': accomIndex,
        'checkIn': checkIn,
        'checkOut': checkOut,
        'adults': adults,
        'children': children,
        'infants': infants,
        'accommodationTypeFilter': accommodationTypeFilter
      };
      // add dealCode to urlParams if deal code is currently applied.
      if (self.queryString.getParameter('dealCode') && self.queryString.getParameter('dealCode') != "") {
        urlParams.dealCode = self.queryString.getParameter('dealCode');
      }

      // this appends history for mobile back button
      let bookingUrl = new URL(window.location.href);

      if (!bookingUrl.searchParams.has('previewPaneOpen')) {
        bookingUrl.searchParams.append('previewPaneOpen', true);
        bookingUrl.searchParams.delete('openPreviewWindow', true);
        window.history.replaceState({}, "", bookingUrl);
      }

      const embedUrl = self.createUrl(urlParams)
      self.createIframe(embedUrl, accomIndex);
      removeLoadingSpinner(self.$wrapper)
    }
  }
  // createUrl - Creates the URL for the iframe
  // @param {object} params - The parameters to use in the URL
  // @returns {string} - The Embed URL
  createUrl = (params) => {
    const self = this;
    // park_availability.html#/?parkCode=TEST&checkIn=2024-11-27&checkOut=2024-11-29&adults=3&children=0&infants=0&accommodationTypeFilter=['All']&accommodationCode=TEST-1-7-RT
    //var returnUrl = `/park_availability#?parkCode=${params.parkCode}&checkIn=${params.checkIn}&checkOut=${params.checkOut}&adults=${params.adults}&children=${params.children}&infants=${params.infants}&accommodationTypeFilter=['${params.accommodationTypeFilter}']&accommodationCode=${params.accommodationRoomCode}`
    var isDhp = $('html').hasClass('dhp-theme');
    var caller = isDhp ? 'dhpWeb' : 'gdayWeb';
    var gtmTag = isDhp ? "GTM-WDLRNW" : "GTM-KCW5WKF";

    var returnUrl = `/park_availability.html#/?parkCode=${params.parkCode}&checkIn=${params.checkIn}&checkOut=${params.checkOut}&adults=${params.adults}&children=${params.children}&infants=${params.infants}&accommodationTypeFilter=['${params.accommodationTypeFilter}']&accommodationCode=${params.accommodationRoomCode}&index=${params.accomIndex}`
    if (params.hasOwnProperty('dealCode') && params.dealCode != "") {
      returnUrl += `&appliedDealId=${params.dealCode}`
    }
    returnUrl += '&msg_receiver=' + self.msg_receiver + '&caller=' + caller + '&gtmTag=' + gtmTag;
    return returnUrl
  }
}
